import axios from 'axios';

export async function createPaymentIntent(paymentData) {
  const {data} = await axios.post('/api/?entity=billing&action=createPaymentIntent', paymentData);
  return data && data.data;
}
